import React from 'react'
import BaseIcon from './BaseIcon'
import img from 'assets/img/ic-unselect-file.png'

const UnselectHeadIcon = (props: any) => {
  return <BaseIcon img={img} onClick={props.onClick} size={props.size} />
}

export default UnselectHeadIcon
